import util from '../common/util.js';
export default {
  util,
  state: {
    msg: {
      timeout: 39000, //39s
      show: false,
      data: {
        title: '',
        text: '',
        type: 'success',
        redirect: null,
      },
      reloadableKey: new Date().getTime(),
    },
  },
  mutations: {
    refreshReloadableMsgKey(state) {
      state.msg.reloadableKey = new Date().getTime()
    },
    hidemsg(state) {
      state.msg.show = false
      state.msg.data.text = ''

      if (state.msg.data.redirect != null) {
        util.linkRedirect(state.msg.data.redirect);
      }

    },
    showmsg(state, msg) {
      // console.log('showmsg')
      this.commit('refreshReloadableMsgKey');
      state.msg.data = Object.assign({}, state.msg.data, msg);
      state.msg.show = true;
    },
    tooglemsg(state, show) {
      state.msg.show = show
    },

    showDefaultErrorMsg(state) {
      this.commit('showmsg', {
        text: 'Erro ao carregar',
        type: 'error'
      })
    }
  },
}
